import { Box } from '@mui/material';
import { falsyCheckDate } from 'utils';
import { DataCellProps } from '../types';

export const DataDeletionArchivedAtCell = ({ team }: DataCellProps) => {
  return <Box>{falsyCheckDate(team.archivedAt)}</Box>;
};
